export const restaurantOrdersZh = {
  title: {
    deliveryTakeaway: 'Delivery 与自取',
    deliveryTakeawayConfiguration: 'Delivery 与自取配置',
    orderHistoryDocument: '订单历史 · Delivery 与自取',
    orderHubEyebrow: '订单中心',
    operationalManagement: '运营管理',
  },
  workspace: {
    selectBranchToManage: '请选择门店以管理{{title}}。',
    newOrder: '新建订单',
    searchOrderPlaceholder: '搜索订单…',
    orderTypeAriaLabel: '订单类型',
    channelDelivery: 'DELIVERY',
    channelTakeaway: '自取',
    processedAriaLabel: '已处理',
    processedTitle: '已处理订单',
    processed: '已处理',
    refreshOrdersLabel: '刷新订单',
    refreshOrdersTitle: '刷新订单',
    attentionLabel: '待处理',
    unsupportedStatesAlert: '{{count}} 个订单的 API 状态与新工作流程不兼容。',
    unsupportedStatesHint:
      '这些订单会显示在日历中，但无法自动分配到看板列。请检查后端返回的状态。',
  },
  board: {
    elapsedNow: '刚刚',
    elapsedMinutesAgo: '{{minutes}} 分钟前',
    elapsedHoursAgo: '{{hours}} 小时前',
    elapsedDaysAgo: '{{days}} 天前',
    productsCount: '{{count}} 件商品',
    paymentMethodTitle: '支付方式',
    orderCardAriaLabel: '订单 {{id}} · {{name}}。按 Enter 打开，按空格键拖动。',
    columnSubtitles: {
      inArrivo: '待审核的新订单',
      accettato: '已确认的订单',
      inLavorazione: '正在准备的订单',
      pronto: '可取餐或配送',
    },
    archiveReadyTitle: '归档已就绪订单',
    archiveReadyAriaLabel: '归档已就绪订单',
    dropHere: '拖放到此处',
    noOrders: '暂无订单',
    orderUpdatedRetry: '订单已更新。请使用当前状态重试。',
  },
  detail: {
    orderTitle: '订单 #{{id}} · {{channel}}',
    orderDetail: '订单详情',
    refreshOrderLabel: '刷新订单',
    refreshOrderTitle: '刷新订单',
    orderActivityLabel: '订单动态',
    orderActivityTitle: '订单动态',
    loadError: '无法加载订单。',
    scheduledDelivery: '预约配送',
    scheduledPickup: '预约自取',
    deliveryAddress: '配送地址',
    pickupPoint: '自取地点',
    emptyAddress: '—',
    outcome: '结果：',
    orderDishes: '订单商品',
    editDishes: '编辑商品',
    allergens: '过敏原：',
    perDish: '{{price}} / 件',
    deliveryFeeLine: 'Delivery {{fee}}',
    orderUpdatedToast: '订单已更新。',
    operationFailed: '操作失败。请重新加载详情后再试。',
    moveOrder: '移动订单',
    orderNumber: '订单 #{{id}}',
    chooseStatus: '选择状态',
    reopenToStatus: '返回状态',
    chooseOperationalStatus: '选择运营状态',
    orderOutcome: '订单结果',
    chooseReason: '选择原因',
    confirmMove: '确认移动',
    notifyCustomer: '通知顾客',
    doNotNotify: '不通知',
    unpaidTitle: '订单尚未支付',
    unpaidBody: '此订单尚未支付。确定要将其移至“准备中”吗？',
    unpaidHint: '付款将保持待处理状态。此操作不会向顾客扣款。',
    noActivity: '暂无动态记录。',
    depositNotAuthorizedApi: '定金尚未授权。请等待顾客完成付款授权。',
  },
  create: {
    title: '新建订单',
    description: '选择服务，添加商品，并填写顾客信息。',
    loadServicesError: '无法加载服务。',
    loadingServices: '正在加载服务…',
    publishServiceHint: '请在“配置”中发布自取或 Delivery 服务。',
    whichService: '您想使用哪项服务？',
    loadingMenuSlots: '正在加载菜单和时段…',
    loadMenuSlotsError: '无法加载菜单和时段。',
    noModeAvailable: '此服务暂无可用模式。',
    operationFailed: '操作失败。请重试。',
    addAtLeastOneProduct: '请至少添加一件商品。',
    productUnavailable: '有商品已不可用。',
    checkProducts: '请检查商品。',
    enterCustomerName: '请输入顾客的姓名。',
    enterValidPhone: '请输入带国家/地区区号的有效电话号码。',
    fixOrClearEmail: '请更正电子邮箱，或将该字段留空。',
    chooseDayAndSlot: '请选择可用的日期和时间。',
    chooseActiveDriver: '请选择一名在岗配送员，或保留“稍后分配”。',
    enterFullDeliveryAddress: '请输入完整的配送地址，包括门牌号。',
    reloadService: '请重新加载服务。',
    quoteExpired: '报价已过期。请检查详情并刷新摘要。',
    stepsAriaLabel: '新建订单步骤',
    steps: {
      service: '服务',
      products: '商品',
      customer: '顾客',
      confirm: '确认',
    },
    footerProductsTotal: '{{count}} 件商品 · {{total}}',
    footerTotalOrder: '订单总额',
    footerDeliveryInSummary: '摘要中包含配送费',
    wait: '请稍候…',
    stepActions: {
      chooseProducts: '选择商品',
      customerDetails: '顾客信息',
      reviewOrder: '核对订单',
      createOrder: '创建订单',
    },
    channelSectionTitle: '顾客将如何收到订单？',
    channelSectionHint: '自取：顾客上门取餐。Delivery：由我们配送。',
    channelTakeaway: '自取',
    channelDelivery: 'Delivery',
    changeChannelConfirm: '切换模式并清空已添加的商品？',
    whatToOrder: '顾客想点什么？',
    menuCategoriesAriaLabel: '菜单分类',
    allMenu: '完整菜单',
    otherProducts: '其他商品',
    searchProduct: '搜索商品',
    searchProductPlaceholder: '商品名称…',
    fromMenu: '来自菜单',
    addProductAria: '添加 {{name}}',
    compose: '配置',
    add: '添加',
    cartAriaLabel: '订单中的商品',
    yourOrder: '您的订单',
    chooseProductToStart: '请从菜单中选择商品开始点单。',
    noExtraOptions: '无附加选项',
    decreaseQtyAria: '减少数量',
    decreaseQtyForAria: '减少 {{name}} 的数量',
    quantityForAria: '{{name}} 的数量',
    increaseQtyForAria: '增加 {{name}} 的数量',
    anotherConfiguration: '另一种配置',
    removeConfigurationAria: '删除配置 {{index}}',
    subtotal: '小计',
    customerAndFulfillment: '顾客与{{fulfillment}}',
    fulfillmentDelivery: '配送',
    fulfillmentPickup: '自取',
    customerRequiredHint: '姓名和电话为必填项。',
    emailOptional: '电子邮箱（选填）',
    emailPlaceholder: 'customer@example.com',
    fullAddress: '完整地址',
    fullAddressPlaceholder: '街道、门牌号、邮编和城市',
    driver: '配送员',
    assignLater: '稍后分配',
    driversLoadError: '无法加载配送员。您可以稍后再分配。',
    deliveryTime: '配送时间',
    pickupTime: '自取时间',
    bookUntil: '最晚可预订至 {{date}}。',
    notesOptional: '备注（选填）',
    notesPlaceholder: '门禁对讲、后厨说明…',
    reviewAndCreate: '核对并创建订单',
    driverLine: '配送员：',
    toAssign: '待分配',
    afterCreateHint: '创建后，您可以管理订单并申请定金。',
    productConfigHint: '请为此配置选择配料。如需不同的配料，请添加另一种配置。',
    requiredSuffix: ' · 必填',
    quantity: '数量',
    reduceQuantityAria: '减少数量',
    addToOrder: '加入订单',
    saveChanges: '保存更改',
    selection: {
      quantityRange: '请选择 1 到 99 之间的数量。',
      productUnavailableForService: '该商品不适用于此服务。',
      optionUnavailable: '所选选项之一不可用。',
    },
    cartErrors: {
      invalidLine: '订单行无效。',
      maxSameConfiguration: '同一配置最多可添加 99 份。',
      maxConfigurations: '每个订单最多 100 种配置。',
      configurationsRange: '请添加 1 到 100 种配置。',
      invalidAmountOrPercentage: '金额或百分比无效。',
      checkOrderProducts: '请检查订单商品。',
      minimumOrder: '最低订单金额：€ {{amount}}。',
      invalidDeliveryFee: '配送费无效。请重新加载服务。',
    },
  },
  history: {
    selectBranch: '请选择门店以查看订单。',
    subtitleDefault: 'Delivery 与自取',
    searchTitle: '搜索历史记录',
    searchHint: '选择时间段或搜索订单。结果会自动更新。',
    searchPlaceholder: '订单号、顾客、商品或联系方式…',
    moreFilters: '更多筛选',
    invalidDateRange: '日期范围无效。',
    exporting: '正在导出…',
    exportCsv: '导出 CSV',
    exportFailed: '导出失败。未下载任何部分文件。请重试。',
    driversListUnavailable: '配送员列表不可用。',
    searchUnavailable: '搜索不可用。筛选条件未返回经过验证的结果。',
    searching: '正在搜索订单和摘要…',
    exactMatch: '精确匹配',
    containsMatch: '包含文本搜索',
    exactMatchHint: '不包含较长的名称。',
    ordersFound: '找到的订单',
    ordersFoundHint: '基于所选时间段和筛选条件',
    completedValue: '已完成订单金额',
    completedValueHint: '{{count}} 个已完成订单 · 总金额，包含尚未支付的部分',
    stillUnpaid: '仍未支付',
    noUnpaidInResults: '结果中没有未支付订单',
    unpaidInResults: '结果中有 {{count}} 个未支付订单',
    ordersByDriver: '按配送员统计订单',
    ordersByDriverHint: '当前负责人，包括已归档订单。',
    driverSummary: '{{completed}} 个已完成 · {{unpaid}} 待收款',
    orderList: '订单列表',
    orderListHint: '使用“详情”打开订单。',
    resultsPage: '共 {{total}} 条结果 · 第 {{page}} / {{pages}} 页',
    loadingPage: '正在加载页面…',
    noOrdersForFilters: '没有符合这些筛选条件的订单',
    table: {
      order: '订单',
      dateTime: '日期和时间',
      channel: '渠道',
      orderStatus: '订单状态',
      payment: '支付',
      driver: '配送员',
      total: '合计',
      notAssigned: '未分配',
      openOrderAria: '打开订单 {{id}}',
    },
    modalProcessed: '已处理订单',
    modalHistory: '订单历史',
    filters: {
      paid: '已支付',
      unpaid: '未支付',
      allMethods: '所有方式',
      allDrivers: '全部',
      unassigned: '未分配',
      deliveryAndTakeaway: 'Delivery 与自取',
      allStatuses: '全部',
      afterProcessed: '处理后的状态',
      sortBy: '排序方式',
      sortRecent: '最近',
      sortOldest: '最早',
      sortTotalHigh: '金额最高',
      unassignedOnly: '未分配',
      driverFilter: '配送员：{{name}}',
    },
    export: {
      incompleteResults: '结果不完整。请重试。',
      filename: 'order-history.csv',
      headers: {
        order: '订单',
        customer: '顾客',
        email: '电子邮箱',
        phone: '电话',
        schedule: '配送 / 自取',
        channel: '渠道',
        products: '商品',
        driver: '配送员',
        totalEur: '合计 EUR',
        orderStatus: '订单状态',
        paymentStatus: '支付状态',
        paymentMethod: '支付方式',
      },
      productLine: '{{quantity}} × {{name}}',
    },
    pagination: {
      perPage: '每页',
      ordersCount: '{{count}} 个订单',
      previous: '上一页',
      next: '下一页',
    },
    topCustomersHint: '按已完成订单金额排名前 10，涵盖所有筛选结果。',
    noCompletedInResults: '结果中没有已完成订单。',
  },
  drivers: {
    manageHint: '管理可分配到配送任务的协作人员。',
    addDriver: '添加配送员',
    loadError: '无法加载配送员。',
    empty: '尚未配置配送员',
    columns: {
      driver: '配送员',
      phone: '电话',
      status: '状态',
      actions: '操作',
    },
    active: '在岗',
    inactive: '未启用',
    ordersAndMap: '订单与地图',
    deleteTitle: '删除配送员',
    deleteConfirm:
      '确定删除 {{name}}？其访问权限将被撤销，未完成的订单将变为未分配状态。历史记录将予以保留。',
    deleteAction: '删除配送员',
    deletedToast: '配送员已删除。',
    deleteError: '无法删除配送员。',
    editTitle: '编辑配送员',
    newTitle: '新建配送员',
    username: '登录名',
    passwordNew: '密码 · 至少 4 个字符',
    passwordKeep: '新密码（留空则保持当前密码）',
    passwordMinError: '请至少输入 4 个字符。',
    accessHint:
      '配送员通过公开菜单上的踏板摩托车按钮登录。请直接向其提供登录凭据。密码将不会再次显示。',
    activeToggleAria: '配送员在岗',
    activeToggle: '配送员在岗',
    savedToast: '配送员已保存。',
    saveError: '无法保存配送员。',
    createdByDriver: '创建者（配送员）：',
    assignedLabel: '已分配配送员',
    notAssigned: '未分配',
    deactivatedSuffix: ' · 已停用',
    deletedSuffix: ' · 已删除',
    driverLine: '配送员：',
    assignSuccess: '已分配配送员',
    unassignSuccess: '已取消分配',
    assignError: '无法分配配送员。',
    discountCard: '折扣卡',
    giftCard: '礼品卡：',
    giftCardCaptured: '已扣款',
    giftCardReleased: '已释放',
    giftCardReserved: '已预留',
    amountDue: '待收款：',
  },
  config: {
    title: 'Delivery 与自取配置',
    sectionAriaLabel: '自取与 Delivery 服务',
    introTitle: '管理接单方式',
    introBody:
      '使用“编辑”为每项服务设置菜单、日期、时间和支付方式。分享链接或二维码，顾客即可下单。',
    searchPlaceholder: '搜索服务…',
    newService: '新建服务',
    templateLoadError: '无法加载初始数据。',
    servicesLoadError: '无法加载服务。',
    emptySearch: '没有与搜索匹配的服务',
    empty: '尚未配置服务',
    columns: {
      service: '服务',
      orderType: '订单类型',
      visibility: '可见性',
      manageShare: '管理与分享',
    },
    preparationMinutes: '备餐 {{minutes}} 分钟',
    advanceDays: '最多可提前 {{days}} 天下单',
    deliveryPausedSuffix: ' · 已暂停',
    visibleToCustomers: '顾客可见',
    draftNotVisible: '草稿 · 不可见',
    openPage: '打开页面',
    servicesPerPage: '每页服务数',
    range: '第 {{start}}–{{end}} 项，共 {{total}} 项',
    previous: '上一页',
    next: '下一页',
    linkCopied: '链接已复制。',
    copyManually: '请手动复制显示的链接。',
    removedToast: '服务已移除。现有订单将予以保留。',
    removeError: '无法移除服务。',
    shareModalTitle: '顾客链接 · {{name}}',
    published: '已发布',
    draftPublishHint: '草稿 · 发布服务后才能接收订单',
    publicLinkLabel: 'Delivery / 自取公开链接',
    shareHint: '顾客将从此服务已启用的渠道和可用时段中进行选择。',
    removeTitle: '移除服务',
    removeConfirm:
      '确定移除“{{name}}”？该服务将不再接受新订单。现有订单和历史记录将予以保留。',
    removeAction: '移除服务',
    editor: {
      editTitle: '编辑服务',
      newTitle: '新建服务',
      stepService: '1 · 服务',
      stepProducts: '2 · 商品',
      stepSchedulePayments: '3 · 时间与支付',
      savePublish: '保存并发布',
      saveDraft: '保存草稿',
      serviceName: '服务名称',
      serviceNameHint:
        '此名称是顾客通过链接或二维码打开的公开页面标题，用于 Delivery 或自取下单。',
      chooseMenu: '选择菜单',
      menusLoadError: '无法加载菜单。',
      enableTakeaway: '启用自取',
      enableDelivery: '启用 Delivery',
      restaurantPhoto: '餐厅照片（选填）',
      restaurantPhotoHint: '点击从您的设备中选择并上传照片。',
      removeRestaurantPhoto: '删除餐厅照片',
      photoLoading: '正在上传照片…',
      photoUploadedToast: '照片已上传。请保存服务以确认。',
      photoUploadError: '无法上传餐厅照片。',
      photoNoUrl: '上传未返回图片 URL。请重试。',
      productsIntro:
        '选择可用商品及各渠道价格。配料和规格来自共享菜单。如需确认修改后的价格，请点击该字段旁的“保存”。',
      searchProductsPlaceholder: '搜索商品或分区…',
      productsLoadError: '无法加载商品。',
      productsLoading: '正在加载商品…',
      noProducts: '未找到商品',
      chooseMenuFirst: '请先选择菜单',
      sectionControlsHint:
        '{{count}} 件商品 · 控制项适用于整个分区，搜索时同样有效。',
      partial: ' · 部分',
      activeCount: '已启用 {{enabled}}/{{total}}',
      sectionToggleAria: '{{channel}}：整个分区 {{name}}',
      product: '商品',
      takeaway: '自取',
      delivery: 'Delivery',
      options: '配料与选项',
      syncedWithMenu: ' · 已与菜单同步',
      priceAria: '{{channel}} 价格 {{name}}',
      savePriceAria: '保存 {{channel}} 价格 {{name}}',
      invalidPrice: '请输入大于或等于零的有效价格。',
      updateFailed: '更新失败',
      productsUpdatedPartial:
        '已更新 {{completed}} / {{total}} 件商品。未更新：{{failures}}',
      priceUpdatedToast: '价格已更新。',
      productsUpdatedToast: '已更新 {{count}} 件商品。',
      menuLoadFailed: '无法加载菜单。未应用任何更改。',
      recipeSyncHint:
        '已同步商品的开关会立即更新配方，包括菜单以及使用该配方的其他服务。在此保存的价格也会更新菜单和其他服务。“取消”不会撤销这些更改。对于未同步的商品，请保存服务以确认。请在菜单中编辑配料。',
      prepMinutes: '平均备餐时间（分钟）',
      slotMinutes: '配送/自取时段时长（分钟）',
      slotHint:
        '设为 15 分钟时，顾客可选择 19:00–19:15，然后是 19:15–19:30。备餐时间单独设置。',
      advanceDaysLabel: '最长提前下单时间（天）',
      advanceDaysHint:
        '设为 7 天时，顾客可在已配置的营业时间内，为未来 7 天内的日期下单。',
      minimumOrder: '最低订单金额（€）',
      freeDeliveryFrom: '免配送费门槛（€）',
      deliveryRadius: '配送半径（公里）',
      weeklyCalendar: '每周日历 · 接单时间',
      from: '从',
      slotStartAria: '时段 {{index}} 开始',
      slotEndAria: '时段 {{index}} 结束',
      removeSlotAria: '删除时段',
      addSlot: '添加时段',
      paymentMethods: '接受的支付方式',
      cardOnly: '仅限银行卡',
      cashAndCard: '现金与银行卡',
      stripeChecking: '正在检查 Stripe…',
      stripeRequired: '如需启用银行卡支付，请完成 Stripe 设置和门店入驻。',
      cardStripeError: '如需启用银行卡支付，请完成 Stripe 设置和门店入驻。',
      publication: '发布',
      pauseDelivery: '暂时暂停 Delivery',
      pauseDeliveryHint:
        '此服务的 Delivery 部分可暂时停用。取消勾选并保存服务即可重新启用。如已启用，自取仍然可用。',
      publishService: '发布服务',
      savedPublishedToast: '服务已保存并发布。',
      savedDraftToast: '草稿已保存。',
      saveError: '无法保存服务。',
      pendingPrices: '继续之前，请使用各字段旁的按钮保存已修改的价格。',
      distanceBandsUnsupported: '需要更新关联的 API 才能保存距离区间。',
      distanceBandsNotReturned:
        '服务器未返回已保存的区间。配置仍保持打开：请重新加载服务后再试。',
      productDetailsTitle: '商品详情 · {{name}}',
      productDetails: '商品详情',
      closeDetails: '关闭详情',
      ingredients: '配料：',
      allergens: '过敏原：',
      notSpecified: '未指定',
      noOptionsForChannel: '此渠道没有选项',
      group: '分组',
      ingredient: '配料',
      supplement: '加料',
      minMax: '最少 {{min}}{{max}}',
      maxSuffix: ' · 最多 {{max}}',
      weekdays: {
        monday: '星期一',
        tuesday: '星期二',
        wednesday: '星期三',
        thursday: '星期四',
        friday: '星期五',
        saturday: '星期六',
        sunday: '星期日',
      },
    },
    validation: {
      serviceName: '请输入服务名称（最多 120 个字符）。',
      chooseMenu: '请选择服务菜单。',
      enableChannel: '请至少启用 Delivery 或自取。',
      integerRange: '{{label}}：请输入 {{min}} 到 {{max}} 之间的整数。',
      preparation: '备餐',
      slotDuration: '时段时长',
      bookableDays: '可预订天数',
      amounts: '请输入正数金额，最多保留两位小数。',
      deliveryRadius: '配送半径必须大于 0 且不超过 100 公里。',
      timezone: '请输入有效的时区。',
      location: '请在门店配置中补全地址和坐标。',
      geocoding: '未配置配送范围验证服务。',
      openingHours: '请输入 1 到 28 个营业时段。',
      openingHoursOrder: '请检查营业时段：结束时间必须晚于开始时间。',
      enableProduct: '请至少为一个已启用的渠道启用一件商品。',
      productPrices: '请检查商品价格。',
    },
  },
  modals: {
    archive: {
      title: '归档已就绪订单',
      intro:
        '所选订单将被归档：Delivery 订单标记为已送达，自取订单标记为已取餐。支付方式保持不变。',
      markAllPaid: '将所有所选订单标记为已支付',
      deliverySection: 'Delivery · 已送达',
      takeawaySection: '自取 · 已取餐',
      paid: '已支付',
      noReadyOrders: '没有已就绪的订单。',
      archiving: '正在归档…',
      archiveCount: '归档 {{count}} 个订单',
      archiveError: '归档失败。请重新加载订单后再试。',
    },
    processed: {
      title: '已处理订单 · {{date}}',
      searchPlaceholder: '搜索顾客、电话或订单号…',
      orderOutcome: '订单结果',
      allReasons: '所有原因',
      empty: '没有已归档订单',
      columns: {
        order: '订单',
        channel: '渠道',
        schedule: '配送 / 自取时间',
        total: '合计',
        driver: '配送员',
        outcome: '结果',
        payment: '支付',
      },
      perPage: '每页',
      ordersCount: '{{count}} 个订单',
      previous: '上一页',
      next: '下一页',
    },
    payment: {
      cardTitle: '银行卡支付',
      loadingStripe: '正在加载 Stripe 表单…',
      loadError: '无法加载支付。订单已保存，正在等待支付。',
      retryPayment: '重试支付',
      payAmount: '支付 {{amount}}',
      confirmedOnPayment: '收到付款后，订单将被确认。',
      paymentFailed: '支付失败。请重试。',
      paymentIncomplete: '支付未完成。请重试。',
      verifyFailed: '无法验证支付。请对同一订单重试。',
    },
    itemsEditor: {
      title: '编辑商品',
      titleWithOrder: '编辑商品 · 订单 #{{id}}',
      loadError: '编辑订单需要新的后端 API。未更改任何数据。',
      loadingMenu: '正在加载菜单…',
      notEditable: '此订单在当前状态下无法编辑。',
      saveError: '无法保存。如其他操作员已修改该订单，请重新加载订单。',
      menuChannel: '菜单 · {{channel}}',
      searchPlaceholder: '搜索菜品或分区…',
      orderItems: '订单商品 · {{count}}',
      removeDishAria: '删除菜品',
      quantity: '数量',
      decreaseQtyAria: '减少数量',
      optionIssue: '请检查所选配料的可用性及最少/最多数量。',
      addAtLeastOne: '请至少添加一件商品。如需取消订单，请使用专门的操作。',
      verifiedTotal: '已验证的新总额',
      recalcHint:
        '保存前，服务器会重新计算价格和加料。在点击“保存更改”之前，修改仅保留在本地。',
      verifyTotal: '验证新总额',
      saveChanges: '保存更改',
      unsavedConfirm: '不保存商品更改并离开？',
      dishFallback: '商品 {{index}}',
    },
  },
  address: {
    suggestionsUnavailable: '建议不可用。请稍后重试以选择街道。',
    searching: '正在搜索地址…',
    suggestionsCount:
      '共 {{count}} 个建议地址。使用方向键选择，按 Enter 确认。',
    notFound: '未找到地址。请检查街道并补充城市。',
    verifyStreet: '正在验证街道和门牌号…',
    verifyFailed: '我们无法验证该街道。请重新选择一个建议以重试。',
    selectFromSuggestions: '继续之前，请从建议中选择街道。',
    deliveryAddressSrOnly: '配送地址',
    placeholder: '街道、门牌号、城市和邮编',
    suggestedAddressesAria: '建议地址',
    hint: '请从建议中选择街道，并补全门牌号。',
    streetNumber: '门牌号 *',
    streetNumberPlaceholder: '例如 10、10/A',
    deliveryAddressPreview: '配送地址：',
    yourAddress: '您的地址',
    streetOnlyCity: '请从建议中选择具体街道，而不仅仅是城市或区域。',
    fullAddressItaly: '请选择意大利境内包含街道和城市的完整地址。',
    streetNumberRequired: '请输入门牌号以继续。',
    streetNumberInvalid: '请输入有效的门牌号，例如 10、10/A 或 10 bis。',
  },
  pricing: {
    ariaLabel: '配送费用',
    title: '您如何计算配送费用？',
    intro: '可为所有顾客设置统一费用，或为每个距离区间设置总价。',
    fixedCost: '固定费用',
    distanceBands: '距离区间',
    fixedFeeLabel: '每单配送费（€）',
    fixedFeeHint: '配送半径内所有地址适用相同金额。',
    bandsUnsupported:
      '关联的 API 暂不支持保存区间。您可以在此先行准备；服务更新后即可保存。',
    bandsFlow: '1. 地址位于 {{radius}} 公里半径内 → 2. 道路路线 → 3. 区间费用',
    bandsFlowHint:
      '价格为配送总费用。公里数为从门店到顾客的单程道路距离。最后一个区间涵盖已接受地址的所有更远距离。',
    allDistances: '所有距离',
    overKm: '超过 {{km}} 公里',
    lastBandHint: '最后一个区间 · 无额外道路里程限制',
    bandUpTo: '区间 {{index}} · 最远（公里）',
    bandFromZero: '从 0 公里起，含上限。',
    bandAfterPrevious: '超过 {{km}} 公里后，含上限。',
    bandCost: '区间 {{index}} · 总费用（€）',
    removeBandAria: '删除区间 {{index}}',
    addBand: '添加区间',
    bandChecksAria: '区间检查',
    simulateDistance: '模拟道路距离（公里）',
    completeBandsForCost: '请补全区间以查看费用。',
    enterValidDistance: '请输入有效的道路距离。',
    costAtDistance: '{{km}} 公里处的配送费：{{price}}',
    previewHint: '区间价格预览，未计入任何免配送费门槛。',
    bandErrors: {
      count: '请输入 1 到 30 个距离区间。',
      lastBand: '区间 {{index}}：最后一个区间涵盖所有更远距离。',
      distance: '区间 {{index}}：请输入大于上一区间的距离，最大 1,000 公里。',
      fee: '区间 {{index}}：请输入 0 到 999,999.99 € 之间的费用，最多保留两位小数。',
    },
  },
  payment: {
    sectionAria: '订单支付',
    paid: '已支付',
    markPaid: '标记为已支付',
    paymentStatus: '支付状态',
    toPay: '待支付',
    saving: '正在保存支付…',
    specialStatusHint: '待处理、已退款或已取消订单的支付需要专门审核。',
    updateError: '无法更新支付。请重新加载订单后再试。',
    branchUnavailable: '门店不可用。',
    deposit: {
      ariaLabel: '申请定金',
      title: '申请定金',
      intro: '请选择占 {{total}} 总额的百分比。顾客将收到付款链接。',
      received: '已收：',
      remaining: '剩余应付：',
      defaultUnavailable: '付款链接不可用：请配置 Stripe。',
      verifyBeforeNew: '在申请新定金之前，需要先审核此订单的支付。',
      creating: '正在创建…',
      linkCreated: '链接已创建',
      createLinkFor: '创建 {{amount}} 的链接',
      requested: '已申请定金：{{amount}}',
      customerLink: '顾客链接',
      messageSent: '消息发送中 / 已发送',
      sending: '正在发送…',
      sendWhatsApp: '通过 WhatsApp 发送给顾客',
      copied: '已复制',
      copyLink: '复制链接',
      copyFromField: '请从上方字段复制链接。',
      whatsAppHint:
        '使用消息中心中配置的“付款链接”消息。创建或发送链接不会将订单标记为已支付。',
      requestMismatch: '返回的请求与所选定金不一致。请重新加载订单。',
      requestUnavailable: '请求不可用。API 服务必须支持订单定金。',
      sendNotConfirmed: '发送未确认。',
      sendError: '无法发送消息。请检查“付款链接”消息的 WhatsApp 配置。',
      invalidPaymentRequest: '付款请求无效。',
      invalidPaymentLink: '付款链接无效。',
    },
  },
  labels: {
    inArrivo: '新到订单',
    accettato: '已接受',
    archiviato: '已处理',
    accept: '接受订单',
    archive: '标记为已处理',
    reopen: '重新打开订单',
    eliminato: '已删除',
    nonConsegnato: '未送达',
    delivery: 'Delivery',
    takeaway: '自取',
    ricevuto: '已收到',
    presaInCarico: '已受理',
    confermato: '已受理',
    inAttesaDiPagamento: '等待付款',
    inLavorazione: '准备中',
    pronto: '已就绪',
    ritirato: '已取餐',
    inConsegna: '配送中',
    consegnato: '已送达',
    rifiutato: '已拒绝',
    annullato: '已取消',
    nonRitirato: '未取餐',
    consegnaFallita: '配送失败',
    daPagare: '待支付',
    inAttesa: '待处理',
    pagato: '已支付',
    parzialmentePagato: '已收定金',
    unspecified: '待确定',
    fallito: '失败',
    rimborsato: '已退款',
    cash: '现金',
    card: '银行卡',
    takeCharge: '受理',
    reject: '拒绝订单',
    prepare: '开始备餐',
    ready: '标记为已就绪',
    assign: '分配配送员',
    dispatch: '出发配送',
    collect: '确认取餐',
    deliver: '确认送达',
    fail: '报告问题',
    cancel: '取消订单',
    cashPaid: '记录现金付款',
    refund: '退款至银行卡',
    cashRefund: '记录现金退款',
    notCollected: '未取餐',
    active: '待处理',
    completed: '已完成',
    issues: '已取消 / 有问题',
    scheduleAsap: '尽快',
  },
};
